import { colors } from '@mui/material';

export const COHORTS_COLORS = [
  colors.red[700],
  colors.pink[700],
  colors.purple[700],
  colors.indigo[500],
  colors.blue[600],
  colors.lightBlue[300],
  colors.cyan[700],
  colors.teal[400],
  colors.green[600],
  colors.lime[600],
  colors.yellow[600],
  colors.orange[500],
  colors.deepOrange[600],
  colors.brown[500],
  colors.grey[700],
  colors.blueGrey[500],
] as const;
